import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal"
}
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_multiselect = _resolveComponent("multiselect")!
  const _component_vue_loading = _resolveComponent("vue-loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _cache[12] || (_cache[12] = _createElementVNode("h1", null, "Отчеты для 1C", -1)),
      _createElementVNode("button", {
        class: "open-modal-btn",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openModal && _ctx.openModal(...args)))
      }, "Выгрузить отчет для 1С"),
      (_ctx.showModal)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _cache[11] || (_cache[11] = _createElementVNode("h2", null, "Выберите месяц и год", -1)),
              _createElementVNode("form", {
                onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _cache[7] || (_cache[7] = _createElementVNode("label", { for: "kato" }, [
                    _createTextVNode("Населенный пункт: "),
                    _createElementVNode("span", { class: "required-sign" }, "*")
                  ], -1)),
                  _createVNode(_component_multiselect, {
                    modelValue: _ctx.kato,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.kato) = $event)),
                    options: _ctx.katoList,
                    searchable: true,
                    closeOnSelect: true,
                    "track-by": "code",
                    "custom-label": _ctx.formattedKatoLabel,
                    placeholder: "Выберите населенный пункт",
                    multiple: false,
                    "clear-on-select": true
                  }, null, 8, ["modelValue", "options", "custom-label"])
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _cache[8] || (_cache[8] = _createElementVNode("label", { for: "accountingMonth" }, [
                    _createTextVNode("Месяц: "),
                    _createElementVNode("span", { class: "required-sign" }, "*")
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    id: "accountingMonth",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.accountingMonth) = $event)),
                    min: "1",
                    max: "12",
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.accountingMonth]
                  ])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _cache[9] || (_cache[9] = _createElementVNode("label", { for: "accountingYear" }, [
                    _createTextVNode("Год: "),
                    _createElementVNode("span", { class: "required-sign" }, "*")
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    id: "accountingYear",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.accountingYear) = $event)),
                    min: "2000",
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.accountingYear]
                  ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _cache[10] || (_cache[10] = _createElementVNode("label", { for: "approveDate" }, "Дата утверждения АВР:", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    id: "approveDate",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.approveDate) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.approveDate]
                  ])
                ]),
                _createElementVNode("button", {
                  type: "submit",
                  class: "submit-btn",
                  disabled: _ctx.isLoading
                }, _toDisplayString(_ctx.isLoading ? 'Выгружается...' : 'Выгрузить'), 9, _hoisted_7)
              ], 32),
              _createElementVNode("button", {
                class: "close-modal-btn",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
              }, "Закрыть")
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_vue_loading, {
      active: _ctx.isLoading,
      "is-full-page": true
    }, null, 8, ["active"])
  ], 64))
}